export const accent = '#573BEE';
